import { AuthBaseClient } from '../base-client';
import type { DashboardMetricKey, DashboardStatsResponse } from './types';

/**
 * Typed client for the dashboard stats endpoint. Tiles fetch only the
 * metrics they render via the `metrics` allowlist — this keeps the
 * wire payload proportional to what the user has on screen.
 */
export class DashboardClient extends AuthBaseClient {
  /**
   * Fetch the requested metrics in one round-trip. `from`/`to` are
   * applied to period-bounded metrics (completion_rate, completed_tasks,
   * referrals_count); static metrics ignore them. Defaults: trailing
   * 30 days.
   */
  async getStats(opts: {
    metrics: readonly DashboardMetricKey[];
    from?: string;
    to?: string;
  }): Promise<DashboardStatsResponse> {
    const params = new URLSearchParams();
    params.set('metrics', opts.metrics.join(','));
    if (opts.from) params.set('from', opts.from);
    if (opts.to) params.set('to', opts.to);
    return this.get<DashboardStatsResponse>(`/api/dashboard/stats?${params.toString()}`);
  }
}
